<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >

    <el-form-item label="巡检分类">
        <el-select  clearable v-model="value" @change="SubordinateChange(value)" placeholder="请选择巡检分类">
            <el-option
            v-for="item in SubordinateList"
            :key="item.id"
            :label="item.typeName"
            :value="item.id">
            </el-option>
        </el-select>
    </el-form-item>
    <el-form-item label="巡检频次">
        <el-input v-model="formLabelAlign.inspectRateNum" size="small"></el-input>
    </el-form-item>
    <el-form-item label="天数">
        <el-input v-model="formLabelAlign.field" size="small"></el-input>
    </el-form-item>
        <el-form-item label="任务周期">
        <el-select  clearable v-model="DutyCyclevalue" @change="DutyCycleChange(DutyCyclevalue)" placeholder="请选择任务周期">
            <el-option
            v-for="item in DutyCycleList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
    </el-form-item>

</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
 components: {},
  name: "PollingTaskDialog",
  data() {
    return {
        dialogVisible: false,
        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},
        SubordinateList:[],
        value:"",
        DutyCyclevalue:"",
        DutyCycleList:[],
        inspectType:"",
    };
  },
  methods: {

    modification(){
      if(this.title == "添加巡检任务"){
        let obj = {
              "inspectType":this.inspectType,
              "inspectRate":this.DutyCyclevalue,
              "inspectRateNum":this.formLabelAlign.inspectRateNum,
              "field":this.formLabelAlign.field
            }
         this.$http.post(this.$requestUrl.POST_TASK_ADD,obj).then((res) => {
            let data = res.data
            if(data.code == 200){
              this.dialogVisible = false
              this.$emit("dialogVisible",false)
                    this.$message({
                        message: "添加成功",
                        type: 'success'
                      });
            }else{
              this.$message.error(data.msg)
            }
          }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
      }else{
      for(let val of this.SubordinateList){
        if(val.typeName == this.value){
          this.inspectType = val.typeName
        }
      }
         let obj = {
           "id":this.formLabelAlign.id,
            "inspectType":this.inspectType,
            "inspectRate":this.DutyCyclevalue,
            "inspectRateNum":this.formLabelAlign.inspectRateNum+"",
            "field":this.formLabelAlign.field
          }
         this.$http.post(this.$requestUrl.POST_TASK_UPDATE,obj).then((res) => {
            let data = res.data
            if(data.code == 200){
                this.dialogVisible = false
                this.$emit("dialogVisible",false)
                        this.$message({
                        message: "修改成功",
                        type: 'success'
                      });
            }else{
              this.$message.error(data.msg)
            }
          }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
      }
    },
    SubordinateChange(res){
      for(let val of this.SubordinateList){
        if(val.id == res){
          this.inspectType = val.typeName
        }
      }
    },
    DutyCycleChange(res){

    },
    handleClose(done) {
      this.dialogVisible = false
    },

  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {

  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>